module.exports = __webpack_public_path__ + "static/media/45-iveco.682e42ae.jpg";